import { Button } from "@/components/core/buttons/button";
import { Form } from "@/components/core/forms/form.tsx";
import {
	FormField,
	FormGroup,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/core/forms/form.tsx";
import { Input } from "@/components/core/forms/input";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { formatDate } from "@/utils/format-date";
import type { CaseActivity } from "../types/activities";

export default function CasePaymentViewModal({ data }: { data: CaseActivity }) {
	const { closeModal } = useModalControl();

	return (
		<div className="w-full">
			<div className="grid grid-cols-12 w-full gap-3">
				<div className="col-span-12 w-full">
					<div className="col-span-12 w-full">
						<div className="flex flex-row w-full gap-4">
							<div className="flex flex-col w-full gap-2">
								<div className="flex flex-col w-full">
									<span className="text-base text-foreground/70">Status</span>
									<span className="text-base font-semibold text-foreground-dark uppercase">
										{data?.status}
									</span>
								</div>
								<div className="flex flex-col w-full">
									<span className="text-base text-foreground/70">
										Date Confirm
									</span>
									<span className="text-base font-semibold text-foreground-dark">
										{formatDate(data?.confirmed_at, "PPp")}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="flex flex-row justify-between w-full gap-4 mt-6">
				<Button
					className=""
					variant="ghost"
					type="button"
					onClick={() => {
						closeModal();
					}}
				>
					Close
				</Button>
			</div>
		</div>
	);
}
